<div class="d-flex flex-column w-100 h-100 confirm-dialog">
  @if (data?.title) {
    <div class="title">
      {{ data.title }}
      <hr />
    </div>
  }
  <div class="message">
    {{ data?.message?.name ? data.message() : data.message }}
  </div>
  @if (data?.footnote) {
    <div class="footnote">{{ data.footnote }}</div>
  }
  <div
    class="actions d-flex flex-grow-1 justify-content-end w-100 align-items-end mt-2 gap-2"
  >
    @if (data?.showCancelBtn) {
      <button class="ra-blue-btn mat-mdc-raised-button" (click)="onCancel()">
        {{ data?.cancelButtonLabel || "Cancel" }}
      </button>
    }
    @if (data?.showSaveBtn) {
      <button class="ra-blue-btn mat-mdc-raised-button" (click)="onSave()">
        {{ data?.saveButtonLabel || "Save" }}
      </button>
    }
    <button class="ra-blue-btn mat-mdc-raised-button" (click)="onOk()">
      {{ data?.okButtonLabel || "Ok" }}
    </button>
  </div>
</div>
